// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"16":"7112840a","678":"component---src-pages-index-js"}[chunkId] + "-" + {"16":"b3c3b264560a7af63f9d","678":"3d73e10dae15f6125c6b"}[chunkId] + ".js";
};